import { Icon } from "ui";
import SearchIcon from "core/icons/search/search-black.svg";
import { TextFieldProps } from "..";
import { TextField, IconWrapper } from "./_TextFieldWithLeftIconStyle";

type Props = TextFieldProps & {
  leftIcon?: "search" | string;
  iconPosition?: "left" | "right";
  placeholder?: string;
  width?: string;
};

function TextFieldWithLeftIcon(props: Props) {
  const { leftIcon, prefixContent, onChange, value, iconPosition, ...rest } = props;

  return (
    <TextField
      onChange={onChange}
      value={value}
      height="40px"
      iconPosition={iconPosition}
      prefixContent={
        <IconWrapper className="icon-wrapper-text-field" iconPosition={iconPosition}>
          {prefixContent ? (
            prefixContent
          ) : (
            <Icon src={leftIcon === "search" ? SearchIcon : leftIcon} />
          )}
        </IconWrapper>
      }
      {...rest}
    />
  );
}

TextFieldWithLeftIcon.defaultProps = {
  iconPosition: "left",
};

export default TextFieldWithLeftIcon;
